/** @jsxImportSource @emotion/react */
import type React from 'react';
import {
  CheckYourEmail,
  CheckYourEmailSpan,
  FirstSection,
  FirstSectionParagraph,
  Screen,
  SocialIcons,
} from './waitlist-confirmed.styled';
import { VSpace } from '../../chat/settings/account/account-settings';
import type { LoginStepProps } from '../login-shell.types';

export const WaitlistConfirmed: React.FC<LoginStepProps> = () => {
  return (
    <Screen data-testid="waitlist-confirmed-screen">
      <VSpace $h={44} />
      <CheckYourEmail>
        <img src="/key.svg" alt="key" />
        <FirstSection>
          <CheckYourEmailSpan>Nickname,
            <br />
            your spot is confirmed.</CheckYourEmailSpan>
          <FirstSectionParagraph>
            Your invitation to Mailander is locked in.
            <br />
            I'll let you know as soon as access
            <br />
            opens.
          </FirstSectionParagraph>
        </FirstSection>
        <VSpace $h={12} />
        <SocialIcons>
          <a href="https://youtube.com/@chrismailander" target="_blank" rel="noopener noreferrer">
            <img src="/youtube-Icon.svg" alt="youtube" />
          </a>
          <a href="https://www.linkedin.com/in/chris-mailander/" target="_blank" rel="noopener noreferrer">
            <img src="/linked-In-Icon.svg" alt="linkedin" />
          </a>
          <a href="https://x.com/mailander" target="_blank" rel="noopener noreferrer">
            <img src="/x-Icon.svg" alt="x" />
          </a>
        </SocialIcons>
      </CheckYourEmail>
    </Screen>
  );
};
